// This file is generated by a script. Do not edit this file directly.
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from 'react';
export var Callout = function Callout(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.75 3.125a.627.627 0 0 0-.625.625v12.5c0 .344.281.625.625.625h12.5a.627.627 0 0 0 .625-.625V3.75a.627.627 0 0 0-.625-.625zm-2.5.625c0-1.379 1.121-2.5 2.5-2.5h12.5c1.379 0 2.5 1.121 2.5 2.5v12.5c0 1.379-1.121 2.5-2.5 2.5H3.75a2.5 2.5 0 0 1-2.5-2.5zm4.688 1.875h8.125c.519 0 .937.418.937.938 0 .519-.418.937-.937.937h-3.126v6.563c0 .519-.417.937-.937.937a.935.935 0 0 1-.937-.937V7.5H5.937A.935.935 0 0 1 5 6.563c0-.52.418-.938.938-.938"
  }));
};
